import { makeStyles } from '@material-ui/core';

export const useChallengeStyles = makeStyles(theme => ({
  tab: {
    marginBottom: '10vh',
  },
}));
